<template>
    <div class="footer-links-box link-list link-list__base" v-bind="cmsEditHelperAttrs">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <ul class="u-reset link-list--list">
            <li v-for="link in content.links" class="link-list--item">
                <router-link :to="link" class="u-reset link-list--link">
                    <span class="link-list--text" v-html="link.label"></span>
                    <span class="link-list--icon">
                        <cmp-icon symbol="chevron_right" size="x-small"></cmp-icon>
                    </span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?4a8be4ac